
import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ScreenshotsSection from './components/ScreenshotsSection';

const HomePage = () => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-[#FFF8F0]">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturesSection />
          <ScreenshotsSection />
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};

export default HomePage;
